"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactCardBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const DropDownButton_1 = require("../DropDownButton");
const ContactCardBody_style_1 = require("./ContactCardBody.style");
function ContactCardBody({ onFormControlsChangedEvent, validate, }) {
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const options = (0, react_1.useMemo)(() => [
        {
            label: t('tool.qrcode.company'),
            value: 'company',
            isSelected: false,
        },
        {
            label: t('tool.qrcode.address'),
            value: 'address',
            isSelected: false,
        },
        {
            label: t('tool.qrcode.website'),
            value: 'website',
            isSelected: false,
        },
        {
            label: t('tool.qrcode.birthday'),
            value: 'birthday',
            isSelected: false,
        },
    ], []);
    const [additionalInputs, setAdditionalInputs] = (0, react_1.useState)([]);
    const [availableOptions, setAvailableOptions] = (0, react_1.useState)(options);
    const [isValid, setIsValid] = (0, react_1.useState)({});
    const handleInputChange = (0, react_1.useCallback)((value, type) => {
        const isValid = validate(value, type);
        setIsValid(function (prev) {
            return Object.assign(Object.assign({}, prev), { [type]: isValid });
        });
        onFormControlsChangedEvent(value, type);
    }, [onFormControlsChangedEvent, validate]);
    const onAddAdditionalInputEvent = (value, index) => {
        const selectedOption = availableOptions[index];
        setAvailableOptions(availableOptions.filter((option) => option.value !== selectedOption.value));
        switch (selectedOption.value) {
            case 'company':
            case 'address':
            case 'website':
                setAdditionalInputs([
                    ...additionalInputs,
                    (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { id: selectedOption.value, name: selectedOption.value, label: t(`tool.qrcode.${selectedOption.value}`), placeholder: t(`tool.qrcode.enter_${selectedOption.value}`), onChange: (value) => handleInputChange(value, selectedOption.value), type: 'text' }, selectedOption.value),
                ]);
                break;
            case 'birthday':
                setAdditionalInputs([
                    ...additionalInputs,
                    (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { id: selectedOption.value, name: selectedOption.value, label: t(`tool.qrcode.${selectedOption.value}`), placeholder: t(`tool.qrcode.enter_${selectedOption.value}`), type: 'date', onChange: (value) => handleInputChange(value, selectedOption.value) }, selectedOption.value),
                ]);
                break;
        }
    };
    return ((0, jsx_runtime_1.jsxs)(ContactCardBody_style_1.StyledContainer, { children: [(0, jsx_runtime_1.jsxs)(ui_common_components_1.FormGrid, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { name: 'firstname', id: 'firstname', type: 'text', size: "Medium", label: t('tool.qrcode.first_name'), placeholder: t('tool.qrcode.enter_first_name'), onChange: (value) => handleInputChange(value, 'firstname') }, 'firstname'), (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { name: 'lastname', id: 'lastname', type: 'text', label: t('tool.qrcode.last_name'), placeholder: t('tool.qrcode.enter_last_name'), onChange: (value) => handleInputChange(value, 'lastname') }, 'lastname'), (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { name: 'phone', id: 'phone', type: 'text', label: t('tool.qrcode.phone'), placeholder: t('tool.qrcode.enter_phone'), errorMessage: isValid['phone'] === false
                            ? t('tool.qrcode.invalid_phone')
                            : undefined, onChange: (value) => handleInputChange(value, 'phone') }, 'phone'), (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { name: 'email', id: 'email', type: 'email', label: t('tool.qrcode.email'), placeholder: t('tool.qrcode.enter_email'), onChange: (value) => handleInputChange(value, 'email') }, 'email'), (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { name: 'job-title', id: 'job-title', type: 'text', label: t('tool.qrcode.job_title'), placeholder: t('tool.qrcode.enter_job_title'), onChange: (value) => handleInputChange(value, 'job-title') }, 'job-title'), additionalInputs] }), availableOptions.length > 0 && ((0, jsx_runtime_1.jsx)(DropDownButton_1.DropDownButton, { onSelectItem: onAddAdditionalInputEvent, buttonVariant: 'outline', options: availableOptions, icon: 'plus', buttonText: t('tool.qrcode.add_more_information') }))] }));
}
exports.ContactCardBody = ContactCardBody;
//# sourceMappingURL=ContactCardBody.js.map